// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-container {
    padding: 2rem;
    max-width: 700px;
    margin: 0 auto;
    text-align: center;
}

.status-title {
    margin-bottom: 2rem;
}

.status-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
}

/* Spinner animation */
.spinner {
    width: 48px;
    height: 48px;
    border: 5px solid #ddd;
    border-top-color: #4caf50;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Success icon animation */
.success-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #4caf50;
    position: relative;
    animation: pop 0.4s ease-out forwards;
}

    .success-icon::after {
        content: "";
        position: absolute;
        left: 18px;
        top: 28px;
        width: 20px;
        height: 10px;
        border-left: 4px solid white;
        border-bottom: 4px solid white;
        transform: rotate(-45deg);
    }

@keyframes pop {
    0% {
        transform: scale(0.4);
        opacity: 0;
    }

    80% {
        transform: scale(1.15);
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.status-message {
    font-size: 1.1rem;
    color: #555;
}

.status-success {
    font-size: 1.3rem;
    font-weight: 600;
    color: #2e7d32;
}

.status-info {
    max-width: 500px;
    line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/assets/Documents/css/StatusPage.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,2BAA2B;AAC3B;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;AACzC;;IAEI;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,WAAW;QACX,YAAY;QACZ,4BAA4B;QAC5B,8BAA8B;QAC9B,yBAAyB;IAC7B;;AAEJ;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["@import '../../../css/App.css';\r\n\r\n.status-container {\r\n    padding: 2rem;\r\n    max-width: 700px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n}\r\n\r\n.status-title {\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.status-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1.25rem;\r\n}\r\n\r\n/* Spinner animation */\r\n.spinner {\r\n    width: 48px;\r\n    height: 48px;\r\n    border: 5px solid #ddd;\r\n    border-top-color: #4caf50;\r\n    border-radius: 50%;\r\n    animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n    to {\r\n        transform: rotate(360deg);\r\n    }\r\n}\r\n\r\n/* Success icon animation */\r\n.success-icon {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n    background: #4caf50;\r\n    position: relative;\r\n    animation: pop 0.4s ease-out forwards;\r\n}\r\n\r\n    .success-icon::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 18px;\r\n        top: 28px;\r\n        width: 20px;\r\n        height: 10px;\r\n        border-left: 4px solid white;\r\n        border-bottom: 4px solid white;\r\n        transform: rotate(-45deg);\r\n    }\r\n\r\n@keyframes pop {\r\n    0% {\r\n        transform: scale(0.4);\r\n        opacity: 0;\r\n    }\r\n\r\n    80% {\r\n        transform: scale(1.15);\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.status-message {\r\n    font-size: 1.1rem;\r\n    color: #555;\r\n}\r\n\r\n.status-success {\r\n    font-size: 1.3rem;\r\n    font-weight: 600;\r\n    color: #2e7d32;\r\n}\r\n\r\n.status-info {\r\n    max-width: 500px;\r\n    line-height: 1.6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
